import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContentSection from './components/SeoContentSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssbuyspreadsheet.help';

    // WebSite schema
    const jsonLdSite = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'CSSBuy Spreadsheet',
      url: siteUrl,
      description: 'Guia completo sobre CSSBuy Spreadsheet para comprar da China com segurança. Tabelas comparativas, tutoriais, dicas de frete e estratégias de importação para o Brasil.',
      inLanguage: 'pt-BR',
      potentialAction: {
        '@type': 'SearchAction',
        'target': `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };

    // FAQPage schema
    const jsonLdFaq = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'O que é CSSBuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'CSSBuy Spreadsheet é uma ferramenta de organização usada para comparar e gerenciar compras internacionais da China. Ele permite registrar produtos, preços, lojas e opções de envio em uma única planilha, facilitando a tomada de decisão antes de finalizar qualquer pedido.',
          },
        },
        {
          '@type': 'Question',
          name: 'CSSBuy Spreadsheet é seguro?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sim, o CSSBuy é uma plataforma estabelecida com boa reputação. No entanto, como em qualquer compra internacional, é importante declarar valores corretamente, usar frete rastreado e verificar a reputação das lojas antes de comprar.',
          },
        },
        {
          '@type': 'Question',
          name: 'Como funciona o frete da China para o Brasil?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'O frete varia conforme o peso, dimensões e método de envio escolhido. As opções incluem EMS, China Post, DHL e linhas econômicas. Recomendamos usar frete rastreado e declarar valores realistas para evitar problemas alfandegários.',
          },
        },
        {
          '@type': 'Question',
          name: 'Posso comprar de várias lojas em um só pedido?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sim! Uma das principais vantagens do CSSBuy Spreadsheet é a capacidade de consolidar produtos de diferentes lojas em um único envio, o que reduz significativamente os custos de frete e simplifica o processo de importação.',
          },
        },
        {
          '@type': 'Question',
          name: 'Quanto tempo leva para chegar?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'O prazo de entrega varia de 15 a 45 dias dependendo do método de frete escolhido. Linhas expressas como DHL podem entregar em 7-15 dias, enquanto linhas econômicas podem levar de 30 a 60 dias.',
          },
        },
      ],
    };

    const scriptSiteId = 'home-site-jsonld';
    const scriptFaqId = 'home-faq-jsonld';

    [scriptSiteId, scriptFaqId].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });

    const scriptSite = document.createElement('script');
    scriptSite.id = scriptSiteId;
    scriptSite.type = 'application/ld+json';
    scriptSite.textContent = JSON.stringify(jsonLdSite);
    document.head.appendChild(scriptSite);

    const scriptFaq = document.createElement('script');
    scriptFaq.id = scriptFaqId;
    scriptFaq.type = 'application/ld+json';
    scriptFaq.textContent = JSON.stringify(jsonLdFaq);
    document.head.appendChild(scriptFaq);

    return () => {
      [scriptSiteId, scriptFaqId].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <SeoContentSection />
      <ArticleCardsSection />
      <FaqSection />
      <CtaSection />
      <Footer />
    </div>
  );
}